import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTelegram } from "../lib/telegram";

export function useTelegramBackButton() {
  const { tg, isTelegram } = useTelegram();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isTelegram || !tg) return;

    const isRoot = location.pathname === "/" || location.pathname === "/dashboard";

    if (isRoot) {
      tg.BackButton.hide();
    } else {
      tg.BackButton.show();
      const handler = () => navigate(-1);
      tg.BackButton.onClick(handler);
      return () => tg.BackButton.offClick(handler);
    }
  }, [isTelegram, tg, location.pathname, navigate]);
}
